import {
  RENEWAL_WINDOW_SECONDS,
  TIMER_VISIBLE_SECONDS,
  TIMER_VISIBLE_WITH_AUTO_RENEWAL_SECONDS,
  TIMER_WARNING_SECONDS,
} from "./constants";

export const calculateTimerValue = (timestamp: number) =>
  Math.ceil((new Date().getTime() - timestamp) / 1000);

// Порог появления зависит от того, спишутся ли деньги сами: при подключённом автопродлении
// таймер приходит позже, см. константы.
export const isTimerVisible = (currentTimeValue: number, isAutoRenewalActive = false) =>
  Math.abs(currentTimeValue) <= (isAutoRenewalActive
    ? TIMER_VISIBLE_WITH_AUTO_RENEWAL_SECONDS
    : TIMER_VISIBLE_SECONDS);

export const isTimerWarning = (currentTimeValue: number) =>
  Math.abs(currentTimeValue) <= TIMER_WARNING_SECONDS;

export const isRenewalWindowOpen = (currentTimeValue: number) =>
  Math.abs(currentTimeValue) <= RENEWAL_WINDOW_SECONDS;
